// extracted by mini-css-extract-plugin
export var active = "_20-9";
export var backButton = "_20-8";
export var clone = "_20-e";
export var collapseBar = "_20-k";
export var collapseMode = "_20-m";
export var collapsed = "_20-o";
export var dimmed = "_20-i";
export var dragHandle = "_20-c";
export var dropdownIcon = "_20-g";
export var expanding = "_20-n";
export var hidden = "_20-x";
export var iconContainer = "_20-q";
export var iconSwapper = "_20-w";
export var navItem = "_20-6";
export var navItemIcon = "_20-f";
export var navProfile = "_20-7";
export var notificationCountBadge = "_20-j";
export var notificationDot = "_20-r";
export var optionsContainer = "_20-h";
export var primaryNav = "_20-0";
export var primaryNavDivider = "_20-v";
export var primaryNavResizeHandle = "_20-2";
export var primaryNavResizing = "_20-1";
export var primaryNavTabSection = "_20-u";
export var primaryTab = "_20-p";
export var primaryTabIconBox = "_20-s";
export var secondaryNav = "_20-3";
export var selected = "_20-t";
export var settingsNav = "_20-4";
export var settingsNavItems = "_20-5";
export var show = "_20-d";
export var sideNav = "_20-l";
export var teamItem = "_20-a";
export var userProfileItem = "_20-b";